import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_DEAL_STATUSES } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const DealStatuses = {
  namespaced: true,
  state: buildInitialState({
    dealStatusList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setDealStatus: (state, dealStatuses) => {
      state.dealStatusList = dealStatuses
    }
  },
  actions: {
    getDealStatuses: ({ commit }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DEAL_STATUSES, parameters: filters })
        .then(json => json.data)
        .then(dealStatuses => {
          commit('updateStatus', { status: COMPLETE })
          commit('setDealStatus', dealStatuses)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default DealStatuses
